var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.64,
    height: 63.64,
    viewBox: "0 0 63.64 63.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16257",
    "data-name": "Group 16257",
    transform: "translate(-1141.68 -311.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_261",
    "data-name": "Ellipse 261",
    transform: "translate(1141.68 343.5) rotate(-45)",
    fill: "none",
    stroke: "#0082ca",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5887",
    "data-name": "Path 5887",
    d: "M0,0,9.624,9.656,19.292,0",
    transform: "translate(1163.854 338.672)",
    fill: "none",
    stroke: "#0082ca",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.d1574b2778a02e3a344a1f0208ad97ed.svg";
export { ForwardRef as ReactComponent };